import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { createPost, getSocialPostData, getSocialPostDetails, removeSocialPostData } from '../../Redux/SocialPost/Action';
import { FaTrash, FaEdit } from 'react-icons/fa';
import NewGlobalDataTable from '../DataTable/NewGlobalDataTable';
import Icon from '../utility/Icon';
import "./SocialPost.css";


const SocialPost = () => {

const dispatch=useDispatch();
const token=localStorage.getItem("token");
const loginId=localStorage.getItem("loginId");
const [show, setShow] = useState(false);
const [subject, setSubject] = useState('');
const [description, setDescription] = useState('');
const [file, setFile] = useState(null);
const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [search, setSearch] = useState('');
const { postdetails, postdata } = useSelector(store => store.social);
const [isEditing, setIsEditing] = useState(false);
const [postId, setPostId] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

useEffect(() => {
    dispatch(getSocialPostDetails(token));
  }, [dispatch, token]);


 useEffect(() => {
    if (postdata && postdata.length > 0) {
        const data = postdata[0]; 
        setSubject(data.subject || '');
        setDescription(data.description || '');
        setIsEditing(true);
    }
}, [postdata]);

const handleShow = () => {
    setShow(true);
    setIsEditing(false);
};

const handleClose = () => {
    setShow(false); 
    setSubject('');
    setDescription('');
};

const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('description', description);
    if (file) {
        formData.append('file', file); 
      }
    formData.append('postedBy',loginId);
    if(isEditing){
        formData.append('hrmsSocialPostId', postId);
        formData.append('actionType', 'UPDATE'); 
    }else{
        formData.append('actionType', 'CREATE'); 
    }
    
    Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'No, cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(createPost(formData, token)) 
          .then(({ success, error }) => {
            if (success) {
              dispatch(getSocialPostDetails(token));
              handleClose();
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: isEditing ? 'Post details updated successfully!' : 'Post details added successfully!',
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: 'Error!',
                text: error || 'There was an error submitting the post details.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          })
            .catch(() => {
              Swal.fire({
                title: 'Error!',
                text: 'There was an error submitting the post details.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            });
        }
      });
  };

const handleDeleteSocialPost = (postid) => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeSocialPostData(postid,token)) 
        .then(({ success, error }) => {
          if (success) {
            dispatch(getSocialPostDetails(token));
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: `Post removed successfully!`,
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: error || 'There was an error removing the post.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        })
          .catch(() => {
            Swal.fire({
              title: 'Error!',
              text: 'There was an error removing the post.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });
      }
    });
};

const handleEditPost = (row) => {
    dispatch(getSocialPostData(row.hrmsSocialPostId,token));
    setPostId(row.hrmsSocialPostId);
    setShow(true);
    setIsEditing(true);
};


const filteredData = postdetails?.filter(user =>
    user.subject?.toLowerCase().includes(search.toLowerCase()) ||
    user.description?.toLowerCase().includes(search.toLowerCase())  ||
    user.postedByName?.toLowerCase().includes(search.toLowerCase()) 
);

const dataToShow = filteredData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

const columns = [

    {
        name: 'Posted By',
        selector: row => row?.postedByName || "-",
        sortable: true,
    },
    {
        name: 'Subject',
        selector: row => row?.subject || "-", 
        sortable: true,
    },
    {
        name: 'Description',
        selector: row => row?.description || "-", 
        sortable: true,
    },
    {
        name: 'Posted Date',
        selector: row => row?.date ?? "-",
        sortable: true,
    },
    {
        name: 'Action',
        selector: row => row,
        sortable: false,
        cell: row => (
        <div>

          <Icon
            icon={FaEdit}
            variant="warning"
            title="Edit"
            onClick={() => handleEditPost(row)}
          />
       <Icon
         icon={FaTrash}
         variant="danger"
         title="View Comments"
         className="ms-1"           // keep Bootstrap spacing utilities
         onClick={() =>  handleDeleteSocialPost(row.hrmsSocialPostId)}
       />

       </div>
        ),
      },
];


    return (
        <div>
         <Navbar></Navbar>
         <div className="main-content">
         <div className='container-fluid mt-4'>
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center">
                <button className="btn btn-primary" onClick={handleShow}>CREATE POST</button>
            </div>
         </div>


                        <NewGlobalDataTable
                  columns={columns} 
                  data={dataToShow} 
                  tableName={'SOCIAL POST LIST'} 
                  setPageSize={setPageSize} 
                  setPageNumber={setPageNumber}
                  totalRecord={dataToShow.length} 
              />
    


         </div>
         </div>
         {show && (
            <>
            <div className="modal-backdrop fade show"></div>
                <div className="modal fade social-modal show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                        {isEditing ? 'EDIT SOCIAL POST' : 'ADD SOCIAL POST'}
                        </h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="subject" className="form-label">Subject</label>
                            <input
                            type="text"
                            className="form-control"
                            id="subject"
                            name="subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="description" className="form-label">Description</label>
                            <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            rows="3"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                            ></textarea>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="file" className="form-label">Upload Image</label>
                            <input
                            type="file"
                            className="form-control"
                            id="file"
                            name="file"
                            onChange={(e) => setFile(e.target.files[0])}
                            required
                            />
                        </div>
                        <div className="row">
                        <div className="col text-center mt-3">
                            <button type="submit" id="sbmtdata" className="btn btn-success">
                              SUBMIT
                            </button>
                        </div>
                    </div>
                    </form>
                    </div>
                    </div>
                </div>
                </div>
            </>
            )}


       </div>
    );
};

export default SocialPost;